import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "panel", "icon" ]

  toggle() {
    this.panelTarget.classList.toggle("hidden")
    if (this.panelTarget.classList.contains("hidden")) {
      this.iconTarget.classList.remove("fa-chevron-down")
      this.iconTarget.classList.add("fa-chevron-right")
    } else {
      this.iconTarget.classList.remove("fa-chevron-right")
      this.iconTarget.classList.add("fa-chevron-down")
    }
  }
}
